export default __webpack_public_path__ + "static/media/pic4.2ed21994.jpg";